import type { AvailabilityProduct } from '@travelity/api/services';
import { format } from 'date-fns';

type AvailabilityEvent = AvailabilityProduct['events'][number];
export interface CapacityFormRow {
    key: string;
    title: string;
    subtitle: string;
    capacityOptions: Array<{ label: string; value: string }>;
    defaultCapacityValue: string;
    remainingByCapacity: Record<string, number>;
}

export const getPackageItemRowId = (
    event: AvailabilityEvent,
    item: NonNullable<AvailabilityEvent['event']>['plan']['items'][number]
) => {
    return `${event.time}:${item.day_index}:${item.order_index}:${
        item.product?.id ||
        item.product?.name ||
        event.id ||
        event.key ||
        event.time
    }`;
};

export const buildCapacityFormRows = (
    selectedEvent: AvailabilityProduct
): CapacityFormRow[] =>
    selectedEvent.events.flatMap(event => {
        const eventProducts = event.event?.plan.items || [];

        return eventProducts.map(product => {
            const sharedCapacities = product.events.shared.flatMap(
                sharedItem => sharedItem.capacities
            );
            const capacities = product.events.new.capacities || [];

            const capacityOptions = capacities.map(capacity => ({
                label: capacity.reference.name,
                value: capacity.id,
            }));

            const defaultCapacityValue =
                capacities.find(capacity => capacity.optimal)?.id ||
                capacities[0]?.id ||
                '';

            const remainingByCapacity = capacities.reduce<
                Record<string, number>
            >((acc, capacity) => {
                acc[capacity.id] = capacity.vacant;
                return acc;
            }, {});

            return {
                key: getPackageItemRowId(event, product),
                title: product.product?.name || '',
                subtitle: `Day ${product.day_index + 1} - ${format(
                    event.time,
                    'HH:mm'
                )}`,
                capacityOptions,
                defaultCapacityValue,
                remainingByCapacity,
            };
        });
    });
